var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "integration-specific-info-card" },
    [
      _c("tabs", {
        attrs: {
          tabs: _vm.tabs,
          "active-tab": _vm.activeTab,
          "tabs-styling": _vm.tabsStyling,
          "tabs-labels-styling": _vm.tabsLabelsStyling,
          "center-tabs": false
        },
        on: {
          startTabChange: function($event) {
            _vm.activeTab = $event
          }
        }
      }),
      _vm._v(" "),
      _vm.tabs[_vm.activeTab].id === "custom"
        ? _c(
            "div",
            { style: { height: "calc(100% - 60px)", "margin-top": "21px" } },
            [
              _c("Table", {
                attrs: {
                  checkbox: false,
                  removeTableLines: false,
                  loading: _vm.loading,
                  headers: _vm.customAuthHeaders,
                  items: _vm.custom,
                  "add-row-button": false,
                  "action-buttons": false
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.tabs[_vm.activeTab].id === "auth"
        ? _c(
            "div",
            { style: { height: "calc(100% - 60px)", "margin-top": "21px" } },
            [
              _c("Table", {
                attrs: {
                  checkbox: false,
                  removeTableLines: false,
                  loading: _vm.loading,
                  headers: _vm.customAuthHeaders,
                  items: _vm.auth,
                  "add-row-button": false,
                  "action-buttons": false
                }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9eeab294", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9eeab294","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/newComponents/Integrations/IntegrationSpecificInfo.vue
// module id = null
// module chunks = 